export default __webpack_public_path__ + "media/images/admin/money-c93beb0d9b61f5da29b6bf1a221cb375.svg";